import ExcelJS from "exceljs";
import api from "../api";
import { toast } from "react-toastify";
import staticData from "../data/static.json";

export const exportDistrictDatas = async ({
  StartYear,
  EndYear,
  StartMonth,
  EndMonth,
  State,
  Districts,
  setMissingDistricts,
  setShowMissingModal,
  setErrorMessage,
  setShowErrorModal,
}) => {
  try {
    // Step 1: Load template

    const templateFile =
      Number(EndYear) < 2026
        ? `templates/templates.xlsx`
        : `templates/templates1.xlsx`;
    const response = await fetch(templateFile);
    // const response = await fetch("templates/templates.xlsx");
    const arrayBuffer = await response.arrayBuffer();

    // Step 2: Load workbook
    const workbook = new ExcelJS.Workbook();
    await workbook.xlsx.load(arrayBuffer);

    // ✅ SET CALCULATION PROPERTIES FIRST
    workbook.calcProperties = {
      fullCalcOnLoad: true,
      fullPrecision: true,
    };

    const worksheet = workbook.worksheets[0];

    // Fetch data
    const body = {
      State,
      StartMonth,
      EndMonth,
      StartYear,
      EndYear,
    };
    if (Districts && Object.keys(Districts).length > 0) {
      body.Districts = Districts;
    }
    const res = await api.post("/exportcumulative", body);
    console.log("Params", body);
    console.log("Export API response:", res.data);
    if (
      !res.data ||
      !res.data.data ||
      Object.keys(res.data.data).length === 0
    ) {
      throw new Error(
        `No data available for ${State || "selected state"}, ${StartMonth} ${StartYear}.`,
      );
    }

    // ✅ Successful export logic
    const stateLabel = Array.isArray(State) ? State.join(", ") : State;
    toast.success(`Export data fetched successfully for ${stateLabel}`);

    if (res.data.skippedStates?.length > 0) {
      toast.warning(
        `Skipped (no config/data): ${res.data.skippedStates.join(", ")}`,
      );
    }
    if (
      res.data.missingDistrictsByState &&
      Object.keys(res.data.missingDistrictsByState).length > 0
    ) {
      const statesWithMissing = Object.keys(
        res.data.missingDistrictsByState,
      ).join(", ");
      toast.warning(
        `Missing district data for some months in: ${statesWithMissing}`,
      );
    }

    console.log("Export data:", res.data);

    const stateName = res.data.state;
    const districtData = res.data.data || {};
    const yearDisplay =
      res.data.startYear === res.data.endYear
        ? res.data.startYear
        : `${res.data.startYear}-${res.data.endYear}`;
    const mon = res.data.startMonth + "-" + res.data.endMonth;
    console.log("Month duration:", mon);
    const count = res.data.monthCount;
    console.log("Month count:", count);

    const rows = [];

    // Build rows (your existing logic)
    Object.keys(districtData).forEach((district) => {
      const glanceList = districtData[district].districtAtAGlance || [];
      const allDisha = districtData[district].dishaStaffDetails || [];
      const dishaList = allDisha.slice(0, 10);
      const remarksList = allDisha.slice(10);
      const allFacilities =
        districtData[district].detailsOfNACPFacilities || [];

      glanceList.forEach((g) => {
        const row = [
          g.state || stateName,
          g.district || district,
          g.cluster_HQ || "",
          mon || "",
          yearDisplay || "",
          g.reporting_officer || "",
          g.Contact_Number || "",
          g.Email_address || "",
          g.prevalence_rate || "",
          g.estimated_plhivs || "",
          g.first_95 || "",
          g.sec_95 || "",
          g.trd_95 || "",
          g.category || "",
          g.pregnant_positive || "",
          g.hiv_surveillance_year || "",
        ];

        dishaList.forEach((staff) => {
          row.push(
            staff.sanctioned ?? "",
            staff.in_place ?? "",
            staff.no_vacant ?? "",
            staff.vacant_since ?? "",
          );
        });

        const totalStaffCols = 10 * 4;
        const currentStaffCols = dishaList.length * 4;
        if (currentStaffCols < totalStaffCols) {
          row.push(...Array(totalStaffCols - currentStaffCols).fill(""));
        }

        const remarksText = remarksList
          .map((r) => r.remark || "")
          .filter(Boolean)
          .join(" | ");
        row.push(remarksText);

        // ---- IV. Details of NACP facilities (8 metrics each till “Issue related to SOCH reporting”) ----

        const facBlocks = [];
        for (let i = 0; i < 8; i++) facBlocks.push(allFacilities[i] || {});

        const facilityKeys = [
          "TI",
          "LWS",
          "OST_center",
          "Prisons",
          "OCS",
          "One_Stop_Centre",
          "ICTC",
          "SSK",
          "DSRC",
          "ART_Centre",
          "Link_ART_Centre",
          "VL_lab",
        ];

        facilityKeys.forEach((key, keyIndex) => {
          row.push(facBlocks[0][key] ?? "");

          if (keyIndex < 6) {
            row.push(facBlocks[1][key] ?? "");
          } else {
            // row.push(""); // keep column but blank after first 6
          }

          row.push(facBlocks[2][key] ?? "");

          row.push(facBlocks[3][key] ?? "");

          row.push(facBlocks[4][key] ?? "");

          row.push(facBlocks[5][key] ?? "");

          row.push(facBlocks[6][key] ?? "");

          row.push(facBlocks[7][key] ?? "");
        });

        row.push(
          facBlocks[1]["TI"] + facBlocks[1]["LWS"] + facBlocks[1]["OST_center"],
        );

        //  V. Major Performance Indicators
        const perfAch = districtData[district].performance_achievement || {};

        // Extract all 17 rows
        const p1 = Number(perfAch.row1?.achievement) ?? "";
        const p2 = Number(perfAch.row2?.achievement) ?? "";
        const p3 = Number(perfAch.row3?.achievement) ?? "";
        const p4 = Number(perfAch.row4?.achievement) ?? "";
        const p5 = Number(perfAch.row5?.achievement) ?? "";
        const p6 = Number(perfAch.row6?.achievement) ?? "";
        const p7 = Number(perfAch.row7?.achievement) ?? "";
        const p8 = Number(perfAch.row8?.achievement) ?? "";
        const p9 = Number(perfAch.row9?.achievement) ?? "";
        const p10 = Number(perfAch.row10?.achievement) ?? "";
        const p11 = Number(perfAch.row11?.achievement) ?? "";
        const p12 = Number(perfAch.row12?.achievement) ?? "";
        const p13 = Number(perfAch.row13?.achievement) ?? "";
        const p14 = Number(perfAch.row14?.achievement) ?? "";
        const p15 = Number(perfAch.row15?.achievement) ?? "";
        const p16 = Number(perfAch.row16?.achievement) ?? "";
        const p17 = Number(perfAch.row17?.achievement) ?? "";

        //  Calculate percentages
        const vlTestPercent =
          p14 > 0 ? parseFloat(((p15 / p14) * 100).toFixed(2)) : 0;
        const vlSuppressionPercent =
          p15 > 0 ? parseFloat(((p16 / p15) * 100).toFixed(2)) : 0;

        row.push(
          p1,
          p2,
          p3,
          p4,
          p5,
          p6,
          p7,
          p8,
          p9,
          p10,
          p11,
          p12,
          p13,
          p14,
          p15,
          vlTestPercent,
          p16,
          vlSuppressionPercent,
          p17,
        );

        // V. New Registration in the reporting month
        const perfNewReg =
          districtData[district].performance_new_registration || {};

        const nr1 = Number(perfNewReg.row1?.new_registration) ?? "";
        const nr2 = Number(perfNewReg.row2?.new_registration) ?? "";
        const nr3 = Number(perfNewReg.row3?.new_registration) ?? "";
        const nr4 = "";

        row.push(nr1, nr2, nr3, nr4);

        // ---- V. No of LFUs ----
        const perfLFU = districtData[district].performance_no_of_lfus || {};

        const lfu1 = Number(perfLFU.row1?.no_of_lfus) ?? "";
        const lfu2 = Number(perfLFU.row2?.no_of_lfus) ?? "";
        const lfu3 = Number(perfLFU.row3?.no_of_lfus) ?? "";
        const lfu4 = Number(perfLFU.row4?.no_of_lfus) ?? "";
        const lfu5 = Number(perfLFU.row5?.no_of_lfus) ?? "";
        const lfu6 = Number(perfLFU.row6?.no_of_lfus) ?? "";
        const lfu7 = Number(perfLFU.row7?.no_of_lfus) ?? "";

        // Calculate % of PLHIV LFU
        const lfuPercent =
          p14 > 0 ? parseFloat(((lfu5 / p14) * 100).toFixed(2)) : 0;

        row.push(lfu1, lfu2, lfu3, lfu4, lfu5, lfuPercent, lfu6, lfu7);

        // ---- V. Remarks ----
        const perfRemarks = districtData[district].performance_remarks || {};

        const r1 = perfRemarks.row1?.remarks ?? "";
        const r2 = perfRemarks.row2?.remarks ?? "";
        const r3 = perfRemarks.row3?.remarks ?? "";
        const r4 = perfRemarks.row4?.remarks ?? "";
        const r5 = perfRemarks.row5?.remarks ?? "";
        const r6 = perfRemarks.row6?.remarks ?? "";
        const r7 = perfRemarks.row7?.remarks ?? "";
        const r8 = perfRemarks.row8?.remarks ?? "";
        const r9 = perfRemarks.row9?.remarks ?? "";
        const r10 = perfRemarks.row10?.remarks ?? "";
        const r11 = perfRemarks.row11?.remarks ?? "";
        const r12 = perfRemarks.row12?.remarks ?? "";
        const r13 = perfRemarks.row13?.remarks ?? "";
        const r14 = perfRemarks.row14?.remarks ?? "";
        const r15 = perfRemarks.row15?.remarks ?? "";
        const r16 = perfRemarks.row16?.remarks ?? "";
        const r17 = perfRemarks.row17?.remarks ?? "";

        row.push(
          r1,
          r2,
          r3,
          r4,
          r5,
          r6,
          r7,
          r8,
          r9,
          r10,
          r11,
          r12,
          r13,
          r14,
          r15,
          r16,
          r17,
        );

        // VI. EVTHS (Early Viral Testing and Hepatitis Screening)
        const evthsNum = districtData[district].evths_number || {};

        // Extract all 11 rows
        const e1 = Number(evthsNum.row1?.number) ?? "";
        const e2 = Number(evthsNum.row2?.number) ?? "";
        const e3 = Number(evthsNum.row3?.number) ?? "";
        const e4 = Number(evthsNum.row4?.number) ?? "";
        const e5 = Number(evthsNum.row5?.number) ?? "";
        const e6 = Number(evthsNum.row6?.number) ?? "";
        const e7 = Number(evthsNum.row7?.number) ?? "";
        const e8 = Number(evthsNum.row8?.number) ?? "";
        const e9 = Number(evthsNum.row9?.number) ?? "";
        const e10 = Number(evthsNum.row10?.number) ?? "";
        const e11 = Number(evthsNum.row11?.number) ?? "";

        // Calculate percentages
        const pregnantTestedPercent =
          e1 > 0 ? parseFloat(((e2 / e1) * 100).toFixed(2)) : 0;
        const babiesBornPercent =
          e1 > 0 ? parseFloat(((e7 / e1) * 100).toFixed(2)) : 0;
        const babiesOnARTPercent =
          e10 > 0 ? parseFloat(((e11 / e10) * 100).toFixed(2)) : 0;

        // Push data in order with calculated percentages
        row.push(
          e1, // Total no of pregnant women registered in ANC
          e2, // Total no of pregnant women tested for HIV
          pregnantTestedPercent, // % of Pregnant women tested for HIV (CALCULATED)
          e3, // Total no of pregnant women found HIV positive
          e4, // Total no of HIV positive pregnant women initiated on ART
          e5, // Total no of HIV positive pregnant women already on ART
          e6, // Total no of deliveries among HIV positive women
          e7, // Total no of babies born to HIV positive mothers
          babiesBornPercent, // % of Babies born to HIV positive mothers (CALCULATED)
          e8, // Total no of babies initiated on NVP prophylaxis
          e9, // Total no of babies tested at 6 weeks by EID
          e10, // Total no of babies tested positive at 6 weeks by EID
          e11, // Total no of HIV positive babies initiated on ART
          babiesOnARTPercent, // % of HIV positive babies initiated on ART (CALCULATED)
        );

        // VI. EVTHS - No of LFUs
        const evthsLFUs = districtData[district].evths_no_of_lfus || {};

        // Extract all 5 rows
        const l1 = Number(evthsLFUs.row1?.no_of_lfus) ?? "";
        const l2 = Number(evthsLFUs.row2?.no_of_lfus) ?? "";
        const l3 = Number(evthsLFUs.row3?.no_of_lfus) ?? "";
        const l4 = Number(evthsLFUs.row4?.no_of_lfus) ?? "";
        const l5 = Number(evthsLFUs.row5?.no_of_lfus) ?? "";

        // Calculate: row4 - row5 from evths_number (e4 - e5)
        const calculatedLFU = e4 - e5;

        // Push LFUs data with calculated field
        row.push(
          l1, // LFUs for pregnant women registered in ANC
          l2, // LFUs for pregnant women tested for HIV
          calculatedLFU, // CALCULATED: e4 - e5 (HIV+ initiated on ART - HIV+ already on ART)
          l3, // LFUs for pregnant women found HIV positive
          l4, // LFUs for HIV positive pregnant women initiated on ART
          l5, // LFUs for HIV positive pregnant women already on ART
        );

        // VI. EVTHS - Remarks
        const evthsRemarks = districtData[district].evths_remarks || {};

        // Extract all 11 rows
        const r_1 = evthsRemarks.row1?.remarks ?? "";
        const r_2 = evthsRemarks.row2?.remarks ?? "";
        const r_3 = evthsRemarks.row3?.remarks ?? "";
        const r_4 = evthsRemarks.row4?.remarks ?? "";
        const r_5 = evthsRemarks.row5?.remarks ?? "";
        const r_6 = evthsRemarks.row6?.remarks ?? "";
        const r_7 = evthsRemarks.row7?.remarks ?? "";
        const r_8 = evthsRemarks.row8?.remarks ?? "";
        const r_9 = evthsRemarks.row9?.remarks ?? "";
        const r_10 = evthsRemarks.row10?.remarks ?? "";
        const r_11 = evthsRemarks.row11?.remarks ?? "";

        // Push remarks data
        row.push(
          r_1, // Remarks for pregnant women registered in ANC
          r_2, // Remarks for pregnant women tested for HIV
          r_3, // Remarks for pregnant women found HIV positive
          r_4, // Remarks for HIV positive pregnant women initiated on ART
          r_5, // Remarks for HIV positive pregnant women already on ART
          r_6, // Remarks for deliveries among HIV positive women
          r_7, // Remarks for babies born to HIV positive mothers
          r_8, // Remarks for babies initiated on NVP prophylaxis
          r_9, // Remarks for babies tested at 6 weeks by EID
          r_10, // Remarks for babies tested positive at 6 weeks by EID
          r_11, // Remarks for HIV positive babies initiated on ART
        );

        // VI. EVTHS - Target 12
        const evthsTarget12 =
          districtData[district].evths_Target_12?.row1 || {};

        const t12_target = Number(evthsTarget12.Target) ?? "";
        const t12_tested = Number(evthsTarget12.No_tested) ?? "";
        const t12_positive = Number(evthsTarget12.Found_HIV_Positive) ?? "";
        const t12_leftouts = Number(evthsTarget12.Left_Outs) ?? "";
        const t12_remark = evthsTarget12.remark ?? "";

        // VI. EVTHS - Target 13
        const evthsTarget13 =
          districtData[district].evths_Target_13?.row1 || {};

        const t13_target = Number(evthsTarget13.Target) ?? "";
        const t13_tested = Number(evthsTarget13.No_tested) ?? "";
        const t13_positive = Number(evthsTarget13.Found_HIV_Positive) ?? "";
        const t13_leftouts = Number(evthsTarget13.Left_Outs) ?? "";
        const t13_remark = evthsTarget13.remark ?? "";

        // VI. EVTHS - Target 14
        const evthsTarget14 =
          districtData[district].evths_Target_14?.row1 || {};

        const t14_target = Number(evthsTarget14.Target) ?? "";
        const t14_tested = Number(evthsTarget14.No_tested) ?? "";
        const t14_positive = Number(evthsTarget14.Found_HIV_Positive) ?? "";
        const t14_leftouts = Number(evthsTarget14.Left_Outs) ?? "";
        const t14_remark = evthsTarget14.remark ?? "";

        // Push Target 12, 13, 14 data
        row.push(
          t12_target, // Target 12 - Target
          t12_tested, // Target 12 - No tested
          t12_positive, // Target 12 - Found HIV Positive
          t12_leftouts, // Target 12 - Left Outs
          t12_remark, // Target 12 - Remark

          t13_target, // Target 13 - Target
          t13_tested, // Target 13 - No tested
          t13_positive, // Target 13 - Found HIV Positive
          t13_leftouts, // Target 13 - Left Outs
          t13_remark, // Target 13 - Remark

          t14_target, // Target 14 - Target
          t14_tested, // Target 14 - No tested
          t14_positive, // Target 14 - Found HIV Positive
          t14_leftouts, // Target 14 - Left Outs
          t14_remark, // Target 14 - Remark
        );

        // VI. EVTHS - Other (only remark)
        const evthsOther = districtData[district].evths_Other?.row1 || {};

        const other_remark = evthsOther.remark ?? "";

        row.push(other_remark);

        // VII. Campaigns by DISHA
        const campaignsByDisha = districtData[district].campaignsByDisha || [];

        // Campaign 1 - IHC Campaign
        const campaign1 = campaignsByDisha[0] || {};
        const c1_organized = campaign1.camps_organized ?? "";
        const c1_visited = campaign1.camps_visited ?? "";
        const c1_coverage = campaign1.cumulative_coverage ?? "";
        const c1_remarks = campaign1.remarks ?? "";

        // Campaign 2 - Any other
        const campaign2 = campaignsByDisha[1] || {};
        const c2_organized = campaign2.camps_organized ?? "";
        const c2_visited = campaign2.camps_visited ?? "";
        const c2_coverage = campaign2.cumulative_coverage ?? "";
        const c2_remarks = campaign2.remarks ?? "";

        // Push campaigns data
        row.push(
          Number(c1_organized), // IHC Campaign - Camps organized
          Number(c1_visited), // IHC Campaign - Camps visited
          Number(c1_coverage), // IHC Campaign - Cumulative coverage
          c1_remarks, // IHC Campaign - Remarks

          Number(c2_organized), // Any other - Camps organized
          Number(c2_visited), // Any other - Camps visited
          Number(c2_coverage), // Any other - Cumulative coverage
          c2_remarks, // Any other - Remarks
        );

        // VIII. Status of HIV Act
        const statusOfHIVAct = districtData[district].statusOfHIVAct || {};

        const hiv_act_status = statusOfHIVAct.complaints_officer_status ?? "";
        const hiv_act_remarks = statusOfHIVAct.complaints_officer_remarks ?? "";

        // IX. Stigma
        const stigma = districtData[district].stigma?.[0] || {};

        const stigma_description = stigma.stigma_case_description ?? "";

        // Push HIV Act and Stigma data
        row.push(
          Number(hiv_act_status), // Status of HIV Act - Complaints officer status
          hiv_act_remarks, // Status of HIV Act - Complaints officer remarks
          stigma_description, // Stigma - Case description
        );

        // X. Community - CRG
        const communityCRG = districtData[district].community_crg?.row1 || {};

        const crg_constituted = communityCRG.district_crg_constituted ?? "";
        const crg_notification_date = communityCRG.date_of_notification ?? "";

        // X. Community - Comm3
        const communityComm3 =
          districtData[district].community_comm3?.row1 || {};

        const comm3_monthly = communityComm3.Reported_during_the_month ?? "";
        const comm3_cumulative = communityComm3.cumulative_fy ?? "";
        const comm3_remarks = communityComm3.remarks ?? "";

        // X. Community - Comm4
        const communityComm4 =
          districtData[district].community_comm4?.row1 || {};

        const comm4_monthly = communityComm4.Reported_during_the_month ?? "";
        const comm4_cumulative = communityComm4.cumulative_fy ?? "";
        const comm4_remarks = communityComm4.remarks ?? "";

        // X. Community - Comm5
        const communityComm5 =
          districtData[district].community_comm5?.row1 || {};

        const comm5_monthly = communityComm5.Reported_during_the_month ?? "";
        const comm5_cumulative = communityComm5.cumulative_fy ?? "";
        const comm5_remarks = communityComm5.remarks ?? "";

        // X. Community - Comm6
        const communityComm6 =
          districtData[district].community_comm6?.row1 || {};

        const comm6_monthly = communityComm6.Reported_during_the_month ?? "";
        const comm6_cumulative = communityComm6.cumulative_fy ?? "";
        const comm6_remarks = communityComm6.remarks ?? "";

        // X. Community - Comm7
        const communityComm7 =
          districtData[district].community_comm7?.row1 || {};

        const comm7_monthly = communityComm7.Reported_during_the_month ?? "";
        const comm7_cumulative = communityComm7.cumulative_fy ?? "";
        const comm7_remarks = communityComm7.remarks ?? "";

        // Push Community data
        row.push(
          crg_constituted, // Community CRG - District CRG constituted
          crg_notification_date, // Community CRG - Date of notification

          Number(comm3_monthly), // Community Comm3 - Reported during the month
          comm3_cumulative, // Community Comm3 - Cumulative FY
          comm3_remarks, // Community Comm3 - Remarks

          Number(comm4_monthly), // Community Comm4 - Reported during the month
          comm4_cumulative, // Community Comm4 - Cumulative FY
          comm4_remarks, // Community Comm4 - Remarks

          Number(comm5_monthly), // Community Comm5 - Reported during the month
          comm5_cumulative, // Community Comm5 - Cumulative FY
          comm5_remarks, // Community Comm5 - Remarks

          Number(comm6_monthly), // Community Comm6 - Reported during the month
          comm6_cumulative, // Community Comm6 - Cumulative FY
          comm6_remarks, // Community Comm6 - Remarks

          Number(comm7_monthly), // Community Comm7 - Reported during the month
          comm7_cumulative, // Community Comm7 - Cumulative FY
          comm7_remarks, // Community Comm7 - Remarks
        );

        const details = districtData[district].detailsOfNACPFacilities;
        //let totalOfRow0 = 0;
        const firstRow = details[0];
        const totalOfRow0 = Object.values(firstRow).reduce(
          (sum, value) => sum + (Number(value) || 0),
          0,
        );

        console.log("Total of Row 0:", totalOfRow0);

        // XI. Monitoring & Supervision
        const monitoringSupervision =
          districtData[district].monitoringSupervision || {};

        // Row 1
        const ms_row1 = monitoringSupervision.row1?.[0] || {};
        const ms1_total = Number(ms_row1.total_visits) ?? 0;
        const ms1_ti = ms_row1.TI ?? "";
        const ms1_lws = ms_row1.LWS ?? "";
        const ms1_osc = ms_row1.One_Stop_Centre ?? "";
        const ms1_prisons = ms_row1.Prisons ?? "";
        const ms1_ocs = ms_row1.OCS ?? "";
        const ms1_ost = ms_row1.OST_center ?? "";
        const ms1_ictc = ms_row1.ICTC ?? "";
        const ms1_ssk = ms_row1.SSK ?? "";
        const ms1_dsrc = ms_row1.DSRC ?? "";
        const ms1_art = ms_row1.ART_Centre ?? "";
        const ms1_link_art = ms_row1.Link_ART_Centre ?? "";
        const ms1_csc = ms_row1.CSC ?? "";
        const ms1_vl = ms_row1.VL_lab ?? "";
        const ms1_srl = ms_row1.SRL ?? "";

        // Row 2
        const ms_row2 = monitoringSupervision.row2?.[0] || {};
        const ms2_total = Number(ms_row2.total_visits) ?? 0;
        const ms2_ti = ms_row2.TI ?? "";
        const ms2_lws = ms_row2.LWS ?? "";
        const ms2_osc = ms_row2.One_Stop_Centre ?? "";
        const ms2_prisons = ms_row2.Prisons ?? "";
        const ms2_ocs = ms_row2.OCS ?? "";
        const ms2_ost = ms_row2.OST_center ?? "";
        const ms2_ictc = ms_row2.ICTC ?? "";
        const ms2_ssk = ms_row2.SSK ?? "";
        const ms2_dsrc = ms_row2.DSRC ?? "";
        const ms2_art = ms_row2.ART_Centre ?? "";
        const ms2_link_art = ms_row2.Link_ART_Centre ?? "";
        const ms2_csc = ms_row2.CSC ?? "";
        const ms2_vl = ms_row2.VL_lab ?? "";
        const ms2_srl = ms_row2.SRL ?? "";

        // Row 3
        const ms_row3 = monitoringSupervision.row3?.[0] || {};
        const ms3_total = Number(ms_row3.total_visits) ?? 0;
        const ms3_ti = ms_row3.TI ?? "";
        const ms3_lws = ms_row3.LWS ?? "";
        const ms3_osc = ms_row3.One_Stop_Centre ?? "";
        const ms3_prisons = ms_row3.Prisons ?? "";
        const ms3_ocs = ms_row3.OCS ?? "";
        const ms3_ost = ms_row3.OST_center ?? "";
        const ms3_ictc = ms_row3.ICTC ?? "";
        const ms3_ssk = ms_row3.SSK ?? "";
        const ms3_dsrc = ms_row3.DSRC ?? "";
        const ms3_art = ms_row3.ART_Centre ?? "";
        const ms3_link_art = ms_row3.Link_ART_Centre ?? "";
        const ms3_csc = ms_row3.CSC ?? "";
        const ms3_vl = ms_row3.VL_lab ?? "";
        const ms3_srl = ms_row3.SRL ?? "";

        // Row 4
        const ms_row4 = monitoringSupervision.row4?.[0] || {};
        const ms4_total = Number(ms_row4.total_visits) ?? 0;
        const ms4_ti = ms_row4.TI ?? "";
        const ms4_lws = ms_row4.LWS ?? "";
        const ms4_osc = ms_row4.One_Stop_Centre ?? "";
        const ms4_prisons = ms_row4.Prisons ?? "";
        const ms4_ocs = ms_row4.OCS ?? "";
        const ms4_ost = ms_row4.OST_center ?? "";
        const ms4_ictc = ms_row4.ICTC ?? "";
        const ms4_ssk = ms_row4.SSK ?? "";
        const ms4_dsrc = ms_row4.DSRC ?? "";
        const ms4_art = ms_row4.ART_Centre ?? "";
        const ms4_link_art = ms_row4.Link_ART_Centre ?? "";
        const ms4_csc = ms_row4.CSC ?? "";
        const ms4_vl = ms_row4.VL_lab ?? "";
        const ms4_srl = ms_row4.SRL ?? "";

        // Row 5
        const ms_row5 = monitoringSupervision.row5?.[0] || {};
        const ms5_total = Number(ms_row5.total_visits) ?? 0;
        const ms5_ti = ms_row5.TI ?? "";
        const ms5_lws = ms_row5.LWS ?? "";
        const ms5_osc = ms_row5.One_Stop_Centre ?? "";
        const ms5_prisons = ms_row5.Prisons ?? "";
        const ms5_ocs = ms_row5.OCS ?? "";
        const ms5_ost = ms_row5.OST_center ?? "";
        const ms5_ictc = ms_row5.ICTC ?? "";
        const ms5_ssk = ms_row5.SSK ?? "";
        const ms5_dsrc = ms_row5.DSRC ?? "";
        const ms5_art = ms_row5.ART_Centre ?? "";
        const ms5_link_art = ms_row5.Link_ART_Centre ?? "";
        const ms5_csc = ms_row5.CSC ?? "";
        const ms5_vl = ms_row5.VL_lab ?? "";
        const ms5_srl = ms_row5.SRL ?? "";

        // Row 6
        const ms_row6 = monitoringSupervision.row6?.[0] || {};
        const ms6_total = Number(ms_row6.total_visits) ?? 0;
        const ms6_ti = ms_row6.TI ?? "";
        const ms6_lws = ms_row6.LWS ?? "";
        const ms6_osc = ms_row6.One_Stop_Centre ?? "";
        const ms6_prisons = ms_row6.Prisons ?? "";
        const ms6_ocs = ms_row6.OCS ?? "";
        const ms6_ost = ms_row6.OST_center ?? "";
        const ms6_ictc = ms_row6.ICTC ?? "";
        const ms6_ssk = ms_row6.SSK ?? "";
        const ms6_dsrc = ms_row6.DSRC ?? "";
        const ms6_art = ms_row6.ART_Centre ?? "";
        const ms6_link_art = ms_row6.Link_ART_Centre ?? "";
        const ms6_csc = ms_row6.CSC ?? "";
        const ms6_vl = ms_row6.VL_lab ?? "";
        const ms6_srl = ms_row6.SRL ?? "";

        // Row 7
        const ms_row7 = monitoringSupervision.row7?.[0] || {};
        const ms7_total = Number(ms_row7.total_visits) ?? 0;
        const ms7_ti = ms_row7.TI ?? "";
        const ms7_lws = ms_row7.LWS ?? "";
        const ms7_osc = ms_row7.One_Stop_Centre ?? "";
        const ms7_prisons = ms_row7.Prisons ?? "";
        const ms7_ocs = ms_row7.OCS ?? "";
        const ms7_ost = ms_row7.OST_center ?? "";
        const ms7_ictc = ms_row7.ICTC ?? "";
        const ms7_ssk = ms_row7.SSK ?? "";
        const ms7_dsrc = ms_row7.DSRC ?? "";
        const ms7_art = ms_row7.ART_Centre ?? "";
        const ms7_link_art = ms_row7.Link_ART_Centre ?? "";
        const ms7_csc = ms_row7.CSC ?? "";
        const ms7_vl = ms_row7.VL_lab ?? "";
        const ms7_srl = ms_row7.SRL ?? "";

        const msfull_total =
          ms1_total +
          ms2_total +
          ms3_total +
          ms4_total +
          ms5_total +
          ms6_total +
          ms7_total;
        console.log("Full visist:", msfull_total);
        const percent = (msfull_total / count / totalOfRow0) * 100 || 0;

        console.log("Percent:", percent);
        const safeTotal =
          Number.isFinite(percent) && !isNaN(percent) ? percent : "-";
        console.log("safeTotal:", safeTotal);

        const per1 = (ms1_total / totalOfRow0 / count) * 100 || 0;
        const per2 = (ms2_total / totalOfRow0 / count) * 100 || 0;
        const per3 = (ms3_total / totalOfRow0 / count) * 100 || 0;
        const per4 = (ms4_total / totalOfRow0 / count) * 100 || 0;
        const per5 = (ms5_total / totalOfRow0 / count) * 100 || 0;
        const per6 = (ms6_total / totalOfRow0 / count) * 100 || 0;
        const per7 = (ms7_total / totalOfRow0 / count) * 100 || 0;
        console.log("PErcent:", per1, per2, per3, per4, per5, per6, per7);

        console.log(``);

        // Push Monitoring & Supervision data
        row.push(
          totalOfRow0,
          msfull_total,
          safeTotal,

          // Row 1
          ms1_total,
          per1,
          Number(ms1_ti),
          Number(ms1_lws),
          Number(ms1_osc),
          Number(ms1_prisons),
          Number(ms1_ocs),
          Number(ms1_ost),
          Number(ms1_ictc),
          Number(ms1_ssk),
          Number(ms1_dsrc),
          Number(ms1_art),
          Number(ms1_link_art),
          Number(ms1_csc),
          Number(ms1_vl),
          Number(ms1_srl),

          // Row 2
          ms2_total,
          per2,
          Number(ms2_ti),
          Number(ms2_lws),
          Number(ms2_osc),
          Number(ms2_prisons),
          Number(ms2_ocs),
          Number(ms2_ost),
          Number(ms2_ictc),
          Number(ms2_ssk),
          Number(ms2_dsrc),
          Number(ms2_art),
          Number(ms2_link_art),
          Number(ms2_csc),
          Number(ms2_vl),
          Number(ms2_srl),

          // Row 3
          ms3_total,
          per3,
          Number(ms3_ti),
          Number(ms3_lws),
          Number(ms3_osc),
          Number(ms3_prisons),
          Number(ms3_ocs),
          Number(ms3_ost),
          Number(ms3_ictc),
          Number(ms3_ssk),
          Number(ms3_dsrc),
          Number(ms3_art),
          Number(ms3_link_art),
          Number(ms3_csc),
          Number(ms3_vl),
          Number(ms3_srl),
          // Row 4
          ms4_total,
          per4,
          Number(ms4_ti),
          Number(ms4_lws),
          Number(ms4_osc),
          Number(ms4_prisons),
          Number(ms4_ocs),
          Number(ms4_ost),
          Number(ms4_ictc),
          Number(ms4_ssk),
          Number(ms4_dsrc),
          Number(ms4_art),
          Number(ms4_link_art),
          Number(ms4_csc),
          Number(ms4_vl),
          Number(ms4_srl),

          // Row 5
          ms5_total,
          per5,
          Number(ms5_ti),
          Number(ms5_lws),
          Number(ms5_osc),
          Number(ms5_prisons),
          Number(ms5_ocs),
          Number(ms5_ost),
          Number(ms5_ictc),
          Number(ms5_ssk),
          Number(ms5_dsrc),
          Number(ms5_art),
          Number(ms5_link_art),
          Number(ms5_csc),
          Number(ms5_vl),
          Number(ms5_srl),

          // Row 6
          ms6_total,
          per6,
          Number(ms6_ti),
          Number(ms6_lws),
          Number(ms6_osc),
          Number(ms6_prisons),
          Number(ms6_ocs),
          Number(ms6_ost),
          Number(ms6_ictc),
          Number(ms6_ssk),
          Number(ms6_dsrc),
          Number(ms6_art),
          Number(ms6_link_art),
          Number(ms6_csc),
          Number(ms6_vl),
          Number(ms6_srl),

          // Row 7
          ms7_total,
          per7,
          Number(ms7_ti),
          Number(ms7_lws),
          Number(ms7_osc),
          Number(ms7_prisons),
          Number(ms7_ocs),
          Number(ms7_ost),
          Number(ms7_ictc),
          Number(ms7_ssk),
          Number(ms7_dsrc),
          Number(ms7_art),
          Number(ms7_link_art),
          Number(ms7_csc),
          Number(ms7_vl),
          Number(ms7_srl),
        );

        // XII. Qualitative Section 1_2
        const qualitativeSection12 =
          districtData[district].QUALITATIVE_SECTION_1_2?.[0] || {};

        const qs12_proper_display = qualitativeSection12.proper_display ?? "";
        const qs12_remark_1 = qualitativeSection12.remark_1 ?? "";
        const qs12_receive_feedback =
          qualitativeSection12.receive_feedback ?? "";
        const qs12_remark_2 = qualitativeSection12.remark_2 ?? "";

        // XII. Qualitative Section
        const qualitativeSection =
          districtData[district].qualitativeSection?.[0] || {};

        const qs_jd = qualitativeSection.JD ?? "";
        const qs_dd = qualitativeSection.DD ?? "";
        const qs_ad = qualitativeSection.AD ?? "";
        const qs_yrgcare = qualitativeSection.YRGCARE ?? "";
        const dummy_1 = qualitativeSection.YRGCARE1 ?? "";

        // Push Qualitative Sections data
        row.push(
          qs12_proper_display, // Qualitative Section 1_2 - Proper display
          qs12_remark_1, // Qualitative Section 1_2 - Remark 1
          qs12_receive_feedback, // Qualitative Section 1_2 - Receive feedback
          qs12_remark_2, // Qualitative Section 1_2 - Remark 2

          qs_jd, // Qualitative Section - JD
          qs_dd, // Qualitative Section - DD
          qs_ad, // Qualitative Section - AD
          qs_yrgcare, // Qualitative Section - YRGCARE
          dummy_1,
        );

        // XIII. Last DISHA Review Meeting
        const lastDishaReviewMeeting =
          districtData[district].last_disha_review_meeting?.[0] || {};

        const disha_date_1 = lastDishaReviewMeeting.date_1 ?? "";
        const disha_date_2 = lastDishaReviewMeeting.date_2 ?? "";
        const dummy_2 = lastDishaReviewMeeting.date_3 ?? "";
        const dummy_3 = lastDishaReviewMeeting.date_4 ?? "";

        // Push Last DISHA Review Meeting data
        row.push(
          disha_date_1, // Last DISHA Review Meeting - Date 1
          disha_date_2, // Last DISHA Review Meeting - Date 2
          dummy_2,
          dummy_3,
        );

        // XIV. Meetings
        const meetings = districtData[district].meetings || {};

        // Row 1
        const meet_row1 = meetings.row1 || {};
        const m1_date = meet_row1.date_of_meeting ?? "";
        const m1_total = meet_row1.Total_No_of_meetings ?? "";
        const m1_persons = meet_row1.No_of_persons_attended ?? "";
        const m1_participants = meet_row1.participants_attended ?? "";
        const m1_last_decisions = meet_row1.last_meeting_key_decisions ?? "";
        const m1_current_decisions =
          meet_row1.Key_decisions_current_meeting ?? "";

        // Row 2
        const meet_row2 = meetings.row2 || {};
        const m2_date = meet_row2.date_of_meeting ?? "";
        const m2_total = meet_row2.Total_No_of_meetings ?? "";
        const m2_persons = meet_row2.No_of_persons_attended ?? "";
        const m2_participants = meet_row2.participants_attended ?? "";
        const m2_last_decisions = meet_row2.last_meeting_key_decisions ?? "";
        const m2_current_decisions =
          meet_row2.Key_decisions_current_meeting ?? "";

        // Row 3
        const meet_row3 = meetings.row3 || {};
        const m3_date = meet_row3.date_of_meeting ?? "";
        const m3_total = meet_row3.Total_No_of_meetings ?? "";
        const m3_persons = meet_row3.No_of_persons_attended ?? "";
        const m3_participants = meet_row3.participants_attended ?? "";
        const m3_last_decisions = meet_row3.last_meeting_key_decisions ?? "";
        const m3_current_decisions =
          meet_row3.Key_decisions_current_meeting ?? "";

        // Row 4
        const meet_row4 = meetings.row4 || {};
        const m4_date = meet_row4.date_of_meeting ?? " ";
        const m4_total = meet_row4.Total_No_of_meetings ?? "";
        const m4_persons = meet_row4.No_of_persons_attended ?? "";
        const m4_participants = meet_row4.participants_attended ?? "";
        const m4_last_decisions = meet_row4.last_meeting_key_decisions ?? "";
        const m4_current_decisions =
          meet_row4.Key_decisions_current_meeting ?? "";

        // Row 5
        const meet_row5 = meetings.row5 || {};
        const m5_date = meet_row5.date_of_meeting ?? "";
        const m5_total = meet_row5.Total_No_of_meetings ?? "";
        const m5_persons = meet_row5.No_of_persons_attended ?? "";
        const m5_participants = meet_row5.participants_attended ?? "";
        const m5_last_decisions = meet_row5.last_meeting_key_decisions ?? "";
        const m5_current_decisions =
          meet_row5.Key_decisions_current_meeting ?? "";

        // Row 6
        const meet_row6 = meetings.row6 || {};
        const m6_date = meet_row6.date_of_meeting ?? "";
        const m6_total = meet_row6.Total_No_of_meetings ?? "";
        const m6_persons = meet_row6.No_of_persons_attended ?? "";
        const m6_participants = meet_row6.participants_attended ?? "";
        const m6_last_decisions = meet_row6.last_meeting_key_decisions ?? "";
        const m6_current_decisions =
          meet_row6.Key_decisions_current_meeting ?? "";

        // Row 7
        const meet_row7 = meetings.row7 || {};
        const m7_date = meet_row7.date_of_meeting ?? "";
        const m7_total = meet_row7.Total_No_of_meetings ?? "";
        const m7_persons = meet_row7.No_of_persons_attended ?? "";
        const m7_participants = meet_row7.participants_attended ?? "";
        const m7_last_decisions = meet_row7.last_meeting_key_decisions ?? "";
        const m7_current_decisions =
          meet_row7.Key_decisions_current_meeting ?? "";

        // Push Meetings data
        row.push(
          // Row 1
          m1_date,
          Number(m1_total),
          m1_persons,
          m1_participants,
          m1_last_decisions,
          m1_current_decisions,

          // Row 2
          m2_date,
          Number(m2_total),
          m2_persons,
          m2_participants,
          m2_last_decisions,
          m2_current_decisions,

          // Row 3
          m3_date,
          Number(m3_total),
          m3_persons,
          m3_participants,
          m3_last_decisions,
          m3_current_decisions,

          // Row 4
          m4_date,
          Number(m4_total),
          m4_persons,
          m4_participants,
          m4_last_decisions,
          m4_current_decisions,

          // Row 5
          m5_date,
          Number(m5_total),
          m5_persons,
          m5_participants,
          m5_last_decisions,
          m5_current_decisions,

          // Row 6
          m6_date,
          Number(m6_total),
          m6_persons,
          m6_participants,
          m6_last_decisions,
          m6_current_decisions,

          // Row 7
          m7_date,
          Number(m7_total),
          m7_persons,
          m7_participants,
          m7_last_decisions,
          m7_current_decisions,
        );

        // XV. Stock Status
        const stockStatus = districtData[district].stockStatus || {};

        // Row 1
        const stock_row1 = stockStatus.row1?.[0] || {};
        const st1_qty = stock_row1.Quantity_available ?? "";
        const st1_months = stock_row1.No_of_months ?? "";
        const st1_remarks = stock_row1.remarks ?? "";

        // Row 2
        const stock_row2 = stockStatus.row2?.[0] || {};
        const st2_qty = stock_row2.Quantity_available ?? "";
        const st2_months = stock_row2.No_of_months ?? "";
        const st2_remarks = stock_row2.remarks ?? "";

        // Row 3
        const stock_row3 = stockStatus.row3?.[0] || {};
        const st3_qty = stock_row3.Quantity_available ?? "";
        const st3_months = stock_row3.No_of_months ?? "";
        const st3_remarks = stock_row3.remarks ?? "";

        // Row 4
        const stock_row4 = stockStatus.row4?.[0] || {};
        const st4_qty = stock_row4.Quantity_available ?? "";
        const st4_months = stock_row4.No_of_months ?? "";
        const st4_remarks = stock_row4.remarks ?? "";

        // Row 5
        const stock_row5 = stockStatus.row5?.[0] || {};
        const st5_qty = stock_row5.Quantity_available ?? "";
        const st5_months = stock_row5.No_of_months ?? "";
        const st5_remarks = stock_row5.remarks ?? "";

        // Row 6
        const stock_row6 = stockStatus.row6?.[0] || {};
        const st6_qty = stock_row6.Quantity_available ?? "";
        const st6_months = stock_row6.No_of_months ?? "";
        const st6_remarks = stock_row6.remarks ?? "";

        // Row 7
        const stock_row7 = stockStatus.row7?.[0] || {};
        const st7_qty = stock_row7.Quantity_available ?? "";
        const st7_months = stock_row7.No_of_months ?? "";
        const st7_remarks = stock_row7.remarks ?? "";

        // Row 8
        const stock_row8 = stockStatus.row8?.[0] || {};
        const st8_qty = stock_row8.Quantity_available ?? "";
        const st8_months = stock_row8.No_of_months ?? "";
        const st8_remarks = stock_row8.remarks ?? "";

        // Row 9
        const stock_row9 = stockStatus.row9?.[0] || {};
        const st9_qty = stock_row9.Quantity_available ?? "";
        const st9_months = stock_row9.No_of_months ?? "";
        const st9_remarks = stock_row9.remarks ?? "";

        // Row 10
        const stock_row10 = stockStatus.row10?.[0] || {};
        const st10_qty = stock_row10.Quantity_available ?? "";
        const st10_months = stock_row10.No_of_months ?? "";
        const st10_remarks = stock_row10.remarks ?? "";

        // Row 11
        const stock_row11 = stockStatus.row11?.[0] || {};
        const st11_qty = stock_row11.Quantity_available ?? "";
        const st11_months = stock_row11.No_of_months ?? "";
        const st11_remarks = stock_row11.remarks ?? "";

        // Row 12
        const stock_row12 = stockStatus.row12?.[0] || {};
        const st12_qty = stock_row12.Quantity_available ?? "";
        const st12_months = stock_row12.No_of_months ?? "";
        const st12_remarks = stock_row12.remarks ?? "";

        // Row 13
        const stock_row13 = stockStatus.row13?.[0] || {};
        const st13_qty = stock_row13.Quantity_available ?? "";
        const st13_months = stock_row13.No_of_months ?? "";
        const st13_remarks = stock_row13.remarks ?? "";

        // Row 14
        const stock_row14 = stockStatus.row14?.[0] || {};
        const st14_qty = stock_row14.Quantity_available ?? "";
        const st14_months = stock_row14.No_of_months ?? "";
        const st14_remarks = stock_row14.remarks ?? "";

        // Row 15
        const stock_row15 = stockStatus.row15?.[0] || {};
        const st15_qty = stock_row15.Quantity_available ?? "";
        const st15_months = stock_row15.No_of_months ?? "";
        const st15_remarks = stock_row15.remarks ?? "";

        // Row 16
        const stock_row16 = stockStatus.row16?.[0] || {};
        const st16_qty = stock_row16.Quantity_available ?? "";
        const st16_months = stock_row16.No_of_months ?? "";
        const st16_remarks = stock_row16.remarks ?? "";

        // Row 17
        const stock_row17 = stockStatus.row17?.[0] || {};
        const st17_qty = stock_row17.Quantity_available ?? "";
        const st17_months = stock_row17.No_of_months ?? "";
        const st17_remarks = stock_row17.remarks ?? "";

        // Row 18
        const stock_row18 = stockStatus.row18?.[0] || {};
        const st18_qty = stock_row18.Quantity_available ?? "";
        const st18_months = stock_row18.No_of_months ?? "";
        const st18_remarks = stock_row18.remarks ?? "";

        // Row 19
        const stock_row19 = stockStatus.row19?.[0] || {};
        const st19_qty = stock_row19.Quantity_available ?? "";
        const st19_months = stock_row19.No_of_months ?? "";
        const st19_remarks = stock_row19.remarks ?? "";

        // Row 20
        const stock_row20 = stockStatus.row20?.[0] || {};
        const st20_qty = stock_row20.Quantity_available ?? "";
        const st20_months = stock_row20.No_of_months ?? "";
        const st20_remarks = stock_row20.remarks ?? "";

        // Row 21
        const stock_row21 = stockStatus.row21?.[0] || {};
        const st21_qty = stock_row21.Quantity_available ?? "";
        const st21_months = stock_row21.No_of_months ?? "";
        const st21_remarks = stock_row21.remarks ?? "";

        // Row 22
        const stock_row22 = stockStatus.row22?.[0] || {};
        const st22_qty = stock_row22.Quantity_available ?? "";
        const st22_months = stock_row22.No_of_months ?? "";
        const st22_remarks = stock_row22.remarks ?? "";

        // Row 23
        const stock_row23 = stockStatus.row23?.[0] || {};
        const st23_qty = stock_row23.Quantity_available ?? "";
        const st23_months = stock_row23.No_of_months ?? "";
        const st23_remarks = stock_row23.remarks ?? "";

        // Row 24
        const stock_row24 = stockStatus.row24?.[0] || {};
        const st24_qty = stock_row24.Quantity_available ?? "";
        const st24_months = stock_row24.No_of_months ?? "";
        const st24_remarks = stock_row24.remarks ?? "";

        // Row 25
        const stock_row25 = stockStatus.row25?.[0] || {};
        const st25_qty = stock_row25.Quantity_available ?? "";
        const st25_months = stock_row25.No_of_months ?? "";
        const st25_remarks = stock_row25.remarks ?? "";

        // Row 26
        const stock_row26 = stockStatus.row26?.[0] || {};
        const st26_qty = stock_row26.Quantity_available ?? "";
        const st26_months = stock_row26.No_of_months ?? "";
        const st26_remarks = stock_row26.remarks ?? "";

        // Row 27
        const stock_row27 = stockStatus.row27?.[0] || {};
        const st27_qty = stock_row27.Quantity_available ?? "";
        const st27_months = stock_row27.No_of_months ?? "";
        const st27_remarks = stock_row27.remarks ?? "";

        // Row 28
        const stock_row28 = stockStatus.row28?.[0] || {};
        const st28_qty = stock_row28.Quantity_available ?? "";
        const st28_months = stock_row28.No_of_months ?? "";
        const st28_remarks = stock_row28.remarks ?? "";

        // Row 29
        const stock_row29 = stockStatus.row29?.[0] || {};
        const st29_qty = stock_row29.Quantity_available ?? "";
        const st29_months = stock_row29.No_of_months ?? "";
        const st29_remarks = stock_row29.remarks ?? "";

        // Row 30
        const stock_row30 = stockStatus.row30?.[0] || {};
        const st30_qty = stock_row30.Quantity_available ?? "";
        const st30_months = stock_row30.No_of_months ?? "";
        const st30_remarks = stock_row30.remarks ?? "";

        // Row 31
        const stock_row31 = stockStatus.row31?.[0] || {};
        const st31_qty = stock_row31.Quantity_available ?? "";
        const st31_months = stock_row31.No_of_months ?? "";
        const st31_remarks = stock_row31.remarks ?? "";

        // Row 32
        const stock_row32 = stockStatus.row32?.[0] || {};
        const st32_qty = stock_row32.Quantity_available ?? "";
        const st32_months = stock_row32.No_of_months ?? "";
        const st32_remarks = stock_row32.remarks ?? "";

        // Row 33
        const stock_row33 = stockStatus.row33?.[0] || {};
        const st33_qty = stock_row33.Quantity_available ?? "";
        const st33_months = stock_row33.No_of_months ?? "";
        const st33_remarks = stock_row33.remarks ?? "";

        // Row 34
        const stock_row34 = stockStatus.row34?.[0] || {};
        const st34_qty = stock_row34.Quantity_available ?? "";
        const st34_months = stock_row34.No_of_months ?? "";
        const st34_remarks = stock_row34.remarks ?? "";

        // Row 35
        const stock_row35 = stockStatus.row35?.[0] || {};
        const st35_qty = stock_row35.Quantity_available ?? "";
        const st35_months = stock_row35.No_of_months ?? "";
        const st35_remarks = stock_row35.remarks ?? "";

        // Row 36
        const stock_row36 = stockStatus.row36?.[0] || {};
        const st36_qty = stock_row36.Quantity_available ?? "";
        const st36_months = stock_row36.No_of_months ?? "";
        const st36_remarks = stock_row36.remarks ?? "";

        // Push Stock Status data
        row.push(
          // Row 1
          st1_qty,
          st1_months,
          st1_remarks,
          // Row 2
          st2_qty,
          st2_months,
          st2_remarks,
          // Row 3
          st3_qty,
          st3_months,
          st3_remarks,
          // Row 4
          st4_qty,
          st4_months,
          st4_remarks,
          // Row 5
          st5_qty,
          st5_months,
          st5_remarks,
          // Row 6
          st6_qty,
          st6_months,
          st6_remarks,
          // Row 7
          st7_qty,
          st7_months,
          st7_remarks,
          // Row 8
          st8_qty,
          st8_months,
          st8_remarks,
          // Row 9
          st9_qty,
          st9_months,
          st9_remarks,
          // Row 10
          st10_qty,
          st10_months,
          st10_remarks,
          // Row 11
          st11_qty,
          st11_months,
          st11_remarks,
          // Row 12
          st12_qty,
          st12_months,
          st12_remarks,
          // Row 13
          st13_qty,
          st13_months,
          st13_remarks,
          // Row 14
          st14_qty,
          st14_months,
          st14_remarks,
          // Row 15
          st15_qty,
          st15_months,
          st15_remarks,
          // Row 16
          st16_qty,
          st16_months,
          st16_remarks,
          // Row 17
          st17_qty,
          st17_months,
          st17_remarks,
          // Row 18
          st18_qty,
          st18_months,
          st18_remarks,
          // Row 19
          st19_qty,
          st19_months,
          st19_remarks,
          // Row 20
          st20_qty,
          st20_months,
          st20_remarks,
          // Row 21
          st21_qty,
          st21_months,
          st21_remarks,
          // Row 22
          st22_qty,
          st22_months,
          st22_remarks,
          // Row 23
          st23_qty,
          st23_months,
          st23_remarks,
          // Row 24
          st24_qty,
          st24_months,
          st24_remarks,
          // Row 25
          st25_qty,
          st25_months,
          st25_remarks,
          // Row 26
          st26_qty,
          st26_months,
          st26_remarks,
          // Row 27
          st27_qty,
          st27_months,
          st27_remarks,
          // Row 28
          st28_qty,
          st28_months,
          st28_remarks,
          // Row 29
          st29_qty,
          st29_months,
          st29_remarks,
          // Row 30
          st30_qty,
          st30_months,
          st30_remarks,
          // Row 31
          st31_qty,
          st31_months,
          st31_remarks,
          // Row 32
          st32_qty,
          st32_months,
          st32_remarks,
          // Row 33
          st33_qty,
          st33_months,
          st33_remarks,
          // Row 34
          st34_qty,
          st34_months,
          st34_remarks,
          // Row 35
          st35_qty,
          st35_months,
          st35_remarks,
          // Row 36
          st36_qty,
          st36_months,
          st36_remarks,
        );

        // XVI. Best Practices
        const bestPractices = districtData[district].bestPractices?.[0] || {};

        const bp_data_1 = bestPractices.data_1 ?? "";
        const bp_data_2 = bestPractices.data_2 ?? "";
        const bp_data_3 = bestPractices.data_3 ?? "";
        const bp_data_4 = bestPractices.data_4 ?? "";
        const bp_data_5 = bestPractices.data_5 ?? "";
        const bp_data_6 = bestPractices.data_6 ?? "";
        const dummy_4 = bestPractices.data_7 ?? "";

        // Push Best Practices data
        row.push(
          bp_data_1, // Best Practices - Data 1
          bp_data_2, // Best Practices - Data 2
          bp_data_3, // Best Practices - Data 3
          bp_data_4, // Best Practices - Data 4
          bp_data_5, // Best Practices - Data 5
          bp_data_6, // Best Practices - Data 6
          dummy_4,
        );

        // XVII. Major Problems
        const majorProblem = districtData[district].majorProblem || [];

        // Problem 1
        const mp1 = majorProblem[0] || {};
        const mp1_facility = mp1.name_facility ?? "";
        const mp1_observations = mp1.observations ?? "";
        const mp1_action = mp1.action_initiated_suggested ?? "";

        // Problem 2
        const mp2 = majorProblem[1] || {};
        const mp2_facility = mp2.name_facility ?? "";
        const mp2_observations = mp2.observations ?? "";
        const mp2_action = mp2.action_initiated_suggested ?? "";

        // Problem 3
        const mp3 = majorProblem[2] || {};
        const mp3_facility = mp3.name_facility ?? "";
        const mp3_observations = mp3.observations ?? "";
        const mp3_action = mp3.action_initiated_suggested ?? "";

        // Problem 4
        const mp4 = majorProblem[3] || {};
        const mp4_facility = mp4.name_facility ?? "";
        const mp4_observations = mp4.observations ?? "";
        const mp4_action = mp4.action_initiated_suggested ?? "";

        // Problem 5
        const mp5 = majorProblem[4] || {};
        const mp5_facility = mp5.name_facility ?? "";
        const mp5_observations = mp5.observations ?? "";
        const mp5_action = mp5.action_initiated_suggested ?? "";

        // Problem 6
        const mp6 = majorProblem[5] || {};
        const mp6_facility = mp6.name_facility ?? "";
        const mp6_observations = mp6.observations ?? "";
        const mp6_action = mp6.action_initiated_suggested ?? "";

        // Problem 7
        const mp7 = majorProblem[6] || {};
        const mp7_facility = mp7.name_facility ?? "";
        const mp7_observations = mp7.observations ?? "";
        const mp7_action = mp7.action_initiated_suggested ?? "";

        // Problem 8
        const mp8 = majorProblem[7] || {};
        const mp8_facility = mp8.name_facility ?? "";
        const mp8_observations = mp8.observations ?? "";
        const mp8_action = mp8.action_initiated_suggested ?? "";

        // Problem 9
        const mp9 = {};
        const mp9_facility = "";
        const mp9_observations = "";
        const mp9_action = "";

        // Push Major Problems data
        row.push(
          mp1_facility,
          mp1_observations,
          mp1_action,
          mp2_facility,
          mp2_observations,
          mp2_action,
          mp3_facility,
          mp3_observations,
          mp3_action,
          mp4_facility,
          mp4_observations,
          mp4_action,
          mp5_facility,
          mp5_observations,
          mp5_action,
          mp6_facility,
          mp6_observations,
          mp6_action,
          mp7_facility,
          mp7_observations,
          mp7_action,
          mp8_facility,
          mp8_observations,
          mp8_action,
          mp9_facility,
          mp9_observations,
          mp9_action,
        );

        // XVIII. Support Requested from SACS
        const supportRequestedFromSACS =
          districtData[district].supportRequestedFromSACS?.[0] || {};

        const sacs_support_1 = supportRequestedFromSACS.support_1 ?? "";
        const sacs_support_2 = supportRequestedFromSACS.support_2 ?? "";
        const sacs_support_3 = supportRequestedFromSACS.support_3 ?? "";
        const sacs_support_4 = supportRequestedFromSACS.support_4 ?? "";
        const sacs_support_5 = supportRequestedFromSACS.support_5 ?? "";
        const sacs_support_6 = supportRequestedFromSACS.support_6 ?? "";
        const sacs_support_7 = supportRequestedFromSACS.support_6 ?? "";

        // XIX. Qualitative Section Remarks
        const qualitativeSectionRemarks =
          districtData[district].qualitativeSectionRemarks?.[0] || {};

        const qual_remarks = qualitativeSectionRemarks.Remarks ?? "";

        // Push Support Requested and Qualitative Remarks data
        row.push(
          sacs_support_1, // Support Requested from SACS - Support 1
          sacs_support_2, // Support Requested from SACS - Support 2
          sacs_support_3, // Support Requested from SACS - Support 3
          sacs_support_4, // Support Requested from SACS - Support 4
          sacs_support_5, // Support Requested from SACS - Support 5
          sacs_support_6, // Support Requested from SACS - Support 6
          sacs_support_7,
          qual_remarks, // Qualitative Section Remarks
        );

        row.push(Number(count));

        // ✅ push the completed row

        rows.push(row);
      });
    });

    // ✅ WRITE DATA CELL BY CELL (CRITICAL FIX)
    const startRow = 4;

    rows.forEach((rowData, rowIndex) => {
      const row = worksheet.getRow(startRow + rowIndex);

      rowData.forEach((cellValue, colIndex) => {
        const cell = row.getCell(colIndex + 1);

        // Properly set cell value with type
        if (cellValue === null || cellValue === undefined || cellValue === "") {
          cell.value = null;
        } else if (typeof cellValue === "number") {
          // cell.value = Number(cellValue);
          // cell.numFmt = "0"; // Ensure it's treated as number
          cell.value = cellValue;

          if (Number.isInteger(cellValue)) {
            cell.numFmt = "0";
          } else {
            cell.numFmt = "0.00";
          }
        } else {
          cell.value = String(cellValue);
        }

        // ✅ Touch the cell style to trigger conditional formatting
        if (cell.style) {
          cell.style = { ...cell.style };
        }
      });

      row.commit();
    });

    // ✅ FINAL TOUCH: Mark all data cells as modified
    for (let i = 0; i < rows.length; i++) {
      const row = worksheet.getRow(startRow + i);
      row.eachCell({ includeEmpty: false }, (cell) => {
        // This forces Excel to re-evaluate the cell
        const temp = cell.value;
        cell.value = undefined;
        cell.value = temp;
      });
      // const jsonStateData = staticData[stateName];
      // if (jsonStateData) {
      //   const jsonDistrict = jsonStateData.find(
      //     (item) =>
      //       item["District Name"]?.toLowerCase().trim() ===
      //       (g.district || district)?.toLowerCase().trim()
      //   );

      //   if (jsonDistrict) {
      //     const isDifferent = (a, b) =>
      //       String(a ?? "").trim() !== String(b ?? "").trim();

      //     const colorCell = (col, highlight) => {
      //       if (highlight) {
      //         const cell = row.getCell(col);
      //         cell.fill = {
      //           type: "pattern",
      //           pattern: "solid",
      //           fgColor: { argb: "FFFFFF00" }, // Yellow fill
      //         };
      //       }
      //     };

      //     colorCell(9, isDifferent(g.prevalence_rate, jsonDistrict["Adult Prevalence"]));
      //     colorCell(10, isDifferent(g.estimated_plhivs, jsonDistrict["PLHIV Size"]));
      //     colorCell(14, isDifferent(g.category, jsonDistrict["District Priority"]));
      //   }
      //
      row.commit();
    }

    // Write buffer
    const buffer = await workbook.xlsx.writeBuffer();

    // Download
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    const stateList = Array.isArray(State) ? State : [State];
    const fileLabel = stateList
      .map((s) => {
        const count =
          Districts && Districts[s] && Districts[s].length > 0
            ? Districts[s].length
            : "all";
        return `${s}(${count})`;
      })
      .join("_");
    const now = new Date();

    const formattedDateTime =
      now.getFullYear() +
      "-" +
      String(now.getMonth() + 1).padStart(2, "0") +
      "-" +
      String(now.getDate()).padStart(2, "0") +
      "_" +
      String(now.getHours()).padStart(2, "0") +
      "-" +
      String(now.getMinutes()).padStart(2, "0") +
      "-" +
      String(now.getSeconds()).padStart(2, "0");

    link.setAttribute(
      "download",
      `cumulative_data_${fileLabel}_${formattedDateTime}.xlsx`,
    );
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);

    console.log("✅ Excel exported successfully!");
    return true;
  } catch (err) {
    // Single state: missingDistricts is [{district, missingMonths}]
    // Multi/ALL_STATE: missingDistrictsByState is {stateName: [{district, missingMonths}]}
    const missingSingle = err.response?.data?.missingDistricts;
    const missingMulti = err.response?.data?.missingDistrictsByState;

    if (missingSingle || missingMulti) {
      // Normalize both to {stateName: [{district, missingMonths}]} for uniform rendering
      let normalized;
      if (missingMulti) {
        normalized = missingMulti;
      } else {
        // State is a string for single-state requests
        const stateName = typeof State === "string" ? State : "Unknown State";
        normalized = { [stateName]: missingSingle };
      }
      setMissingDistricts(normalized);
      setShowMissingModal(true);
      return false;
    }

    const apiMsg =
      err.response?.data?.message ||
      err.response?.data?.error ||
      err.message ||
      null;

    const errorText = apiMsg
      ? apiMsg
      : err.response?.status === 404
        ? `No data found for ${State}, ${StartMonth} ${StartYear}. Please check your selection.`
        : "Export failed! Please try again later.";

    setErrorMessage(errorText);
    setShowErrorModal(true);

    console.error("❌ Error exporting Excel:", err);
    return false;
  }
};
